import { useState } from "react";
import { toast } from "sonner";
import { MoonStar, Undo2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

function LaterRow({ m, i, onChange }) {
  const [busy, setBusy] = useState(false);
  const act = async (action) => {
    setBusy(true);
    try { await api.post(`/v2/today/must/${encodeURIComponent(m.id)}/later`, { action }); await onChange(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <li className="rounded-xl bg-white/70 border border-[#EFECE6] p-3" data-testid={`carry-item-${i}`}>
      <p className="text-sm font-semibold text-[#2D2926]">{m.text}</p>
      {m.later ? (
        <div className="flex items-center justify-between mt-2 text-xs">
          <span className="text-[#4F6B55] font-semibold" data-testid={`carry-state-${i}`}>{m.later === "tomorrow" ? "Moved to tomorrow" : "Let go. No penalty."}</span>
          <button disabled={busy} onClick={() => act("undo")} data-testid={`carry-undo-${i}`} className="h-9 px-3 inline-flex items-center gap-1 text-[#635E59]"><Undo2 className="h-3.5 w-3.5" />Undo</button>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-2 mt-2">
          <button disabled={busy} onClick={() => act("tomorrow")} data-testid={`carry-tomorrow-${i}`} className="h-11 rounded-full bg-stone-900 text-white text-sm font-semibold disabled:opacity-50">Tomorrow</button>
          <button disabled={busy} onClick={() => act("let_go")} data-testid={`carry-letgo-${i}`} className="h-11 rounded-full border border-stone-300 text-sm font-semibold disabled:opacity-50">Let it go</button>
        </div>
      )}
    </li>
  );
}

export function EveningCarry({ board, onChange }) {
  const open = board.must_dos.filter((m) => m.status !== "done");
  if (!open.length) return null;
  const { done, total } = board.momentum;
  return (
    <section className="card p-5 bg-[#F3EFE9]" data-testid="evening-carry">
      <span className="eyebrow flex items-center gap-1.5"><MoonStar className="h-3.5 w-3.5" />Before bed</span>
      <p className="font-display text-xl mt-2 leading-snug">{done} of {total} done. What happens to the rest?</p>
      <p className="text-xs text-[#635E59] mt-1">Tomorrow puts it first in tomorrow's plan. Letting it go is a real choice too.</p>
      <ul className="space-y-2 mt-4">{open.map((m, i) => <LaterRow key={m.id} m={m} i={i + 1} onChange={onChange} />)}</ul>
    </section>
  );
}
